@import 'styles/mixins';
@import 'styles/variables';

.tr {
  padding: 0 4px;
  display: flex;
  align-items: flex-end;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  border-bottom: 1px solid $gray-5;
}
